export default __webpack_public_path__ + "static/media/Thug's Belt of the Silent Kill.e0c07da5.jpg";